import React from 'react';
import s from './auth.module.css';

// Form-level auth errors that are not tied to one field. Uses the same tone as
// the rest of the app's overdue/error states, so an error here reads
// consistently with an overdue invoice.
export default function AuthBanner({ title, body }) {
  return (
    <div className={s.banner}>
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" className={s.bannerIcon}>
        <path d="M7 1.5L13 12H1L7 1.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M7 5.5v3M7 10.4v0.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
      <div>
        <div className={s.bannerTitle}>{title}</div>
        {body ? <div className={s.bannerBody}>{body}</div> : null}
      </div>
    </div>
  );
}
